<template>
  <v-dialog v-model="openFailedInfoDialog" scrollable width="80%">
    <v-card>
      <v-card-title class="primary white--text px-3 py-2" v-if="planDetails">
        <span class="text-h6 text-uppercase">
          {{ tripPlanningModule.plan }} Information &nbsp;&nbsp;</span
        >

        <span
          class="text-subtitle-1"
          v-if="
            planDetails &&
            planDetails.plan_name &&
            planDetails.planning_template_data &&
            planDetails.planning_template_data.template_name
          "
        >
          ( &nbsp; {{ planDetails.plan_name }} -
          {{ planDetails.planning_template_data.template_name }}
          &nbsp; )
        </span>

        <v-spacer></v-spacer>
        <v-btn
          id="planInfoClose"
          depressed
          color="white"
          icon
          small
          @click="(openFailedInfoDialog = false), (selectedExport = '')"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="overflow-x-hidden pa-0" v-if="planDetails">
        <v-row no-gutters class="flex-row-reverse pt-4 pr-9">
          <v-col
            cols="12"
            class="pl-12"
            v-if="planDetails && planDetails.warning_message"
          >
            <v-alert dense type="error"
              >{{ planDetails.warning_message }}
            </v-alert>
          </v-col>
          <v-col cols="1" class="d-flex justify-end align-center">
            <v-btn
              id="planInfoExport"
              class="text-uppercase primary"
              :disabled="!selectedExport"
              @click="downloadSummary()"
              >Export</v-btn
            >
          </v-col>
          <v-col cols="3">
            <SelectField
              id="export_option"
              name="export_option"
              :itemsList="selectExport"
              itemText="name"
              itemValue="value"
              dense
              clearable
              v-model="selectedExport"
              hide-details="auto"
              class="mr-2"
              :menu-props="{ offsetY: true }"
              label="Select Export option"
              outlined
            ></SelectField>
          </v-col>
          <!-- <v-col cols="12" class="d-flex align-center justify-center">
            
          </v-col> -->
        </v-row>
        <v-row no-gutters class="pb-4">
          <v-col cols="12" class="px-6">
            <v-row no-gutters justify="space-around" class="simple-title pt-4">
              <v-col>
                <v-card elevation="2" class="mr-3">
                  <v-card-title
                    class="grey px-4 py-1 d-flex align-center justify-center"
                  >
                    <h6 class="primary--text">
                      Planned {{ orderModule.orderPlural }}
                    </h6>
                  </v-card-title>
                  <v-card-text class="text-center py-6">
                    <span v-if="planDetails.planned_orders">
                      {{ planDetails.planned_orders }}
                    </span>
                    <span v-else> 0 </span>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col>
                <v-card elevation="2" class="mr-3">
                  <v-card-title
                    class="grey px-4 py-1 d-flex align-center justify-center"
                  >
                    <h6 class="primary--text">
                      Total {{ orderModule.orderPlural }}
                    </h6>
                  </v-card-title>
                  <v-card-text class="pa-0 text-center py-6">
                    <span v-if="planDetails.total_orders">
                      {{ planDetails.total_orders }}
                    </span>
                    <span v-else> 0 </span>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col>
                <v-card elevation="2" class="mr-3">
                  <v-card-title
                    class="grey px-4 py-1 d-flex align-center justify-center"
                  >
                    <h6 class="primary--text text-truncate">
                      Unplanned {{ orderModule.orderPlural }}
                    </h6>
                  </v-card-title>
                  <v-card-text class="pa-0 text-center py-6">
                    <span v-if="planDetails.unplanned_orders">
                      {{ planDetails.unplanned_orders }}
                    </span>
                    <span v-else> 0 </span>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col>
                <v-card elevation="2" class="mr-3">
                  <v-card-title
                    class="grey px-4 py-1 d-flex align-center justify-center"
                  >
                    <h6 class="primary--text">
                      Unused {{ fleetModule.driverPlural }}
                    </h6>
                  </v-card-title>
                  <v-card-text class="pa-0 text-center py-6">
                    <span v-if="planDetails.unused_drivers">
                      {{ planDetails.unused_drivers }}
                    </span>
                    <span v-else> 0 </span>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col>
                <v-card elevation="2" class="mr-3">
                  <v-card-title
                    class="grey px-4 py-1 d-flex align-center justify-center"
                  >
                    <h6 class="primary--text">
                      Utilized {{ fleetModule.driverPlural }}
                    </h6>
                  </v-card-title>
                  <v-card-text class="pa-0 text-center py-6">
                    <span v-if="planDetails.utilized_drivers">
                      {{ planDetails.utilized_drivers }}
                    </span>
                    <span v-else> 0 </span>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <!-- <v-row class="px-12 pb-12">
          <v-col cols="5">
            <v-row>
              <v-col cols="12 mb-6">
                <h2 class="text-black">Status Information</h2>
                <hr class="bg-black mt-6" style="opacity: 0.4" />
              </v-col>
              <v-col cols="4" class="grey">
                <span class="text-subtitle-1 primary--text"> Status </span>
              </v-col>
              <v-col cols="8" class="grey">
                <span class="text-subtitle-1 primary--text"
                  >Date and Time
                </span>
              </v-col>
            </v-row>
            <v-row v-for="(status, i) in planDetails.trip_events" :key="i">
              <v-col cols="4" class="border-x-light border-bottom-light">
                <span class="text-subtitle-2 text-ligth_grey">
                  {{ Object.keys(status)[0].toString().replace("_", " ") }}
                </span>
              </v-col>
              <v-col cols="8" class="border-right-light border-bottom-light">
                <span class="text-subtitle-2 text-ligth_grey">
                  {{ Object.values(status)[0] }}
                </span>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="1"></v-col>
          <v-col cols="6">
            <v-row>
              <v-col cols="12 mb-6">
                <h2 class="text-black">Loading / Offloading time</h2>
                <hr class="mt-6" style="opacity: 0.4" />
              </v-col>
              <v-col cols="4" class="grey border-light">
                <span class="text-subtitle-1 primary--text"> Name </span>
              </v-col>
              <v-col cols="4" class="grey border-light">
                <span class="text-subtitle-1 primary--text"> Start Time </span>
              </v-col>
              <v-col cols="4" class="grey border-light">
                <span class="text-subtitle-1 primary--text"> End Time </span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4" class="border-light">
                <span class="text-subtitle-2 text-ligth_grey">
                  Loading Time
                </span>
              </v-col>
              <v-col cols="4" class="border-light">
                <span
                  class="text-subtitle-2 text-ligth_grey"
                  v-if="
                    planDetails.planning_template_data &&
                    planDetails.planning_template_data.loading_start_time
                    // planDetails.planning_template_data.loading_time.start_time
                  "
                >
                  {{ planDetails.planning_template_data.loading_start_time }}
                </span>
              </v-col>
              <v-col
                cols="4"
                class="border-light"
                v-if="
                  planDetails.planning_template_data &&
                  planDetails.planning_template_data.loading_end_time
                  // planDetails.planning_template_data.loading_time.start_time
                "
              >
                <span class="text-subtitle-2 text-ligth_grey">
                  {{ planDetails.planning_template_data.loading_end_time }}
                </span>
              </v-col>
              <v-col cols="4" class="border-x-light border-bottom-light">
                <span class="text-subtitle-2 text-ligth_grey">
                  OffLoading Time
                </span>
              </v-col>
              <v-col cols="4" class="border-bottom-light border-right-light">
                <span
                  class="text-subtitle-2 text-ligth_grey"
                  v-if="
                    planDetails.planning_template_data &&
                    planDetails.planning_template_data.offloading_start_time
                  "
                >
                  {{ planDetails.planning_template_data.offloading_start_time }}
                </span>
              </v-col>
              <v-col
                cols="4"
                class="border-right-light border-bottom-light"
                v-if="
                  planDetails.planning_template_data &&
                  planDetails.planning_template_data.offloading_end_time
                  // planDetails.planning_template_data.offloading_time.start_time
                "
              >
                <span class="text-subtitle-2 text-ligth_grey">
                  {{ planDetails.planning_template_data.offloading_end_time }}
                </span>
              </v-col>
            </v-row>
          </v-col>
        </v-row> -->
        <v-row class="px-12 mb-12" v-if="planDetails.planning_template_data">
          <v-col cols="12" md="4" v-if="planEvents && planEvents.length > 0">
            <v-card>
              <v-card-title class="pa-4">
                <span class="text-body-1 font-weight-bold">Event Logs</span>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text class="pa-1">
                <v-list two-line max-height="250px" class="overflow-auto">
                  <v-list-item-group>
                    <template v-for="(item, index) in planEvents">
                      <v-list-item :key="index">
                        <template v-slot:default>
                          <v-list-item-content>
                            <v-list-item-title>
                              <span class="text-body-2">
                                {{ item.event_type }}
                              </span>
                            </v-list-item-title>

                            <v-list-item-subtitle class="pt-2">
                              {{ item.description }}
                            </v-list-item-subtitle>
                          </v-list-item-content>

                          <v-list-item-action>
                            <v-list-item-action-text class="font-weight-bold">
                              {{ item.created }}
                            </v-list-item-action-text>
                          </v-list-item-action>
                        </template>
                      </v-list-item>
                    </template>
                  </v-list-item-group>
                </v-list>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="4">
            <v-row>
              <v-col cols="6" class="d-flex justify-end">
                <span class="text-subtitle-2 text-ligth_grey">
                  Round {{ tripModule.trip }}
                </span>
              </v-col>
              <v-col cols="6" class="d-flex justify-center">
                <v-icon
                  v-if="planDetails.planning_template_data.round_trip"
                  color="primary"
                  >mdi-check-circle</v-icon
                >
                <v-icon v-else color="error">mdi-close-circle</v-icon>
              </v-col>

              <v-col cols="6" class="d-flex justify-end">
                <span class="text-subtitle-2 text-ligth_grey">
                  Zone Constraint
                </span>
              </v-col>
              <v-col cols="6" class="d-flex justify-center">
                <v-icon
                  v-if="planDetails.planning_template_data.zone_constraint"
                  color="primary"
                  >mdi-check-circle</v-icon
                >
                <v-icon v-else color="error">mdi-close-circle</v-icon>
              </v-col>

              <v-col cols="6" class="d-flex justify-end">
                <span class="text-subtitle-2 text-ligth_grey">{{
                  tripPlanningModule.regionRestriction
                }}</span>
              </v-col>
              <v-col cols="6" class="d-flex justify-center">
                <v-icon
                  v-if="planDetails.planning_template_data.region_restriction"
                  color="primary"
                  >mdi-check-circle</v-icon
                >
                <v-icon v-else color="error">mdi-close-circle</v-icon>
              </v-col>

              <v-col cols="6" class="d-flex justify-end">
                <span class="text-subtitle-2 text-ligth_grey">
                  {{ tripPlanningModule.tag }} Validations
                </span>
              </v-col>
              <v-col cols="6" class="d-flex justify-center">
                <v-icon
                  v-if="planDetails.planning_template_data.tag_validations"
                  color="primary"
                  >mdi-check-circle</v-icon
                >
                <v-icon v-else color="error">mdi-close-circle</v-icon>
              </v-col>

              <v-col cols="6" class="d-flex justify-end">
                <span class="text-subtitle-2 text-ligth_grey">
                  Disable time windows
                </span>
              </v-col>
              <v-col cols="6" class="d-flex justify-center">
                <v-icon
                  v-if="planDetails.planning_template_data.disable_time_windows"
                  color="primary"
                  >mdi-check-circle</v-icon
                >
                <v-icon v-else color="error">mdi-close-circle</v-icon>
              </v-col>

              <v-col cols="6" class="d-flex justify-end">
                <span class="text-subtitle-2 text-ligth_grey">
                  Traffic Jams
                </span>
              </v-col>
              <v-col cols="6" class="d-flex justify-center">
                <v-icon
                  v-if="planDetails.planning_template_data.traffic_jams"
                  color="primary"
                  >mdi-check-circle</v-icon
                >
                <v-icon v-else color="error">mdi-close-circle</v-icon>
              </v-col>

              <v-col cols="6" class="d-flex justify-end">
                <span class="text-subtitle-2 text-ligth_grey">
                  Toll Roads
                </span>
              </v-col>
              <v-col cols="6" class="d-flex justify-center">
                <v-icon
                  v-if="planDetails.planning_template_data.toll_roads"
                  color="primary"
                  >mdi-check-circle</v-icon
                >
                <v-icon v-else color="error">mdi-close-circle</v-icon>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="4">
            <v-row>
              <v-col cols="4">
                <span class="text-subtitle-2 text-ligth_grey">
                  {{ tripPlanningModule.template }} Name
                </span>
              </v-col>
              <v-col cols="6">
                <span
                  class="text-subtitle-2 font-weight-light text-ligth_grey text-capitalize"
                >
                  {{ planDetails.planning_template_data.name }}
                </span>
              </v-col>
              <v-col cols="4">
                <span class="text-subtitle-2 text-ligth_grey">
                  Optimization Option
                </span>
              </v-col>
              <v-col cols="6">
                <span
                  class="text-subtitle-2 font-weight-light text-ligth_grey text-capitalize"
                  v-if="planDetails.planning_template_data.configuration"
                >
                  {{
                    planDetails.planning_template_data.configuration.replaceAll(
                      "_",
                      " "
                    )
                  }}
                </span>
              </v-col>
              <v-col cols="4">
                <span class="text-subtitle-2 text-ligth_grey">
                  Fill Ratio
                </span>
              </v-col>
              <v-col cols="6">
                <span
                  v-if="planDetails.planning_template_data.fill_ratio"
                  class="text-subtitle-2 font-weight-light text-ligth_grey text-capitalize"
                >
                  {{ planDetails.planning_template_data.fill_ratio }} %
                </span>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { bus } from "@/main";
import { convertToBlobAndDownload } from "@/utils/functions";
import {
  fleetModule,
  orderModule,
  tripModule,
  tripPlanningModule,
} from "@/utils/moduleMapping";
export default {
  data() {
    return {
      orderModule,
      fleetModule,
      tripModule,
      tripPlanningModule,
      selectExport: [
        {
          name: "Trip Plan Summary",
          value: "trip_plan_summary_report",
        },
        {
          name: "Planned Trips Summary",
          value: "planned_trip_summary_report",
        },
        {
          name: "Planned Orders Summary",
          value: "planned_order_summary_report",
        },
        {
          name: "Unplanned Order Reasons",
          value: "unplanned_order_summary_report",
        },
         {
          name: "Customer Detail Report",
          value: "customer_summary_report",
        },
      ],
      selectedExport: "",
      options: {
        responsive: true,
        legend: {
          display: true,
          position: "right",
        },
      },
      planEvents: [],
    };
  },
  components: {},
  props: {
    value: Boolean,
    planDetails: Object,
  },
  watch: {
    value(val) {
      if (val) {
        this.getTripPlanningEvents(this.planDetails.id);
      }
    },
  },
  computed: {
    openFailedInfoDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    getTripPlanningEvents(id) {
      this.$api.tripPlanning
        .getTripPlanningEvents(id)
        .then((res) => {
          this.planEvents = res.data;
          console.log(this.planInfo);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    downloadSummary() {
      bus.$emit("showLoader", true);
      this.$api.tripPlanning
        .getDownloadFile(this.planDetails.id, this.selectedExport)
        .then(({ data }) => {
          bus.$emit("showLoader", false);
          let file_name = "Trip Plan";
          if (this.planDetails.plan_name) {
            file_name = this.planDetails.plan_name;
          }
          convertToBlobAndDownload(
            data,
            `${file_name} ${this.selectedExport}.xlsx`
          );
        })
        .catch(() => {
          bus.$emit("showLoader", false);
          bus.$emit("showToastMessage", {
            message: "Data not found!",
            color: "error",
          });
        });
    },
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
.simple-title h6 {
  font-size: 14px;
  text-transform: uppercase !important;
  color: black;
}
.simple-title span {
  font-size: 49px;
  font-weight: 900;
}
</style>
